import React from 'react';

const JS_Strict_Mode = () => {
  return (
    <div >
      <h1>JS_Strict_Mode</h1>
      <p>Placeholder component for: "JS Strict Mode"</p>
    </div>
  );
};

export default JS_Strict_Mode;
